/*
дубли тут уже, надо переместить в ed.js наверно функции
 Этот файл общего функционала для всех шаблонов
*/

/*GET запрос данных по JSON. Например: getData('index.php?r=cards',function(result){...}) */
export var joint = {

	getData(url, callBack) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', url);
		xhr.onreadystatechange = function () {
			if (xhr.readyState != 4) return;
			if (xhr.status === 200) {
				callBack(xhr.responseText);
			} else {
				console.log('Ошибка: ' + xhr.status + ': ' + xhr.statusText);
			}
		};
		xhr.send();
	},

	/*******************************************
	* Пример использования:
	*	formData.append("name", e.target.value);
	*	postData(formData, "/", (r)=>{ console.log('r=',r) });
	********************************************/
	postData(data, url, callBack) {
		var xhr = new XMLHttpRequest();
		//xhr.onload = xhr.onerror = callBack;
		var that = this;
		xhr.onreadystatechange = function () {// https://learn.javascript.ru/ajax-xmlhttprequest
			if (this.readyState != 4) return;
			var result = JSON.parse(this.responseText);
			//console.log("result:",result);
			if (result.error !== undefined) {// обработать ошибку
				alert(result.error);
				return;
			}
			callBack(result);
		}
		xhr.open("POST", url, true);
		xhr.send(data);
	},
}

// window.setCookie = (name, obj) => {//sample: setCookie("mode",{edit:1, scale:1, thema:1})
// 	document.cookie = name + "=" + JSON.stringify(obj) + ";max-age=2147483647" + ";path=/;domain=" + location.hostname;
// }
window.setCookie = (name, obj) => {
    try {
        // Проверяем, является ли hostname localhost или IP-адресом
        const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.hostname === '';
        const domainAttr = isLocalhost ? '' : `;domain=${location.hostname}`;
        
        // Устанавливаем куку
        document.cookie = `${name}=${JSON.stringify(obj)};max-age=2147483647;path=/;SameSite=Lax${domainAttr}`;
        console.log('Куки установлены:', document.cookie);
    } catch (e) {
        console.error('Ошибка при установке куки:', e);
    }
};

// window.getCookie = function (name) {
// 	var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
// 	if (match) {
// 		document.cookie = name + '=; Expires=Thu, 01 Jan 1970 00:00:01 GMT';
// 		var b = JSON.parse(decodeURIComponent(match[2]))
// 		//console.log(name + '=', b);
// 		return b;
// 	}
// 	return false;
// }

window.getCookie = function (name) {
    try {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return JSON.parse(parts.pop().split(';').shift());
        }
        return null;
    } catch (e) {
        console.error(`Ошибка при получении куки ${name}:`, e);
        return null;
    }
};

window.updateCookie = (name, key, val) => {
	var obj = getCookie(name);
	if (obj) {
		obj[key] = val;
		setCookie(name, obj);
	} else return false;
}

window.excludElCookie = (name, key) => {//Удалить элемент массива куки
	var obj = getCookie(name);
	if (obj) {
		delete obj[`${key}`];//Для удаления ключа типа int
		setCookie(name, obj);
	} else return false;
}

window.delete_cookie = (name) => {
	//document.cookie = name +'=; Path=/;  Domain=' + location.host +  '; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=None; Secure' 
	document.cookie = name + '=; Path=/;  Domain=' + location.host + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	//document.cookie = name + '=; Expires=Thu, 01 Jan 1970 00:00:01 GMT';
	console.log(`${name} кука удалена`);
}

// window.lkExit = () => {
// 	document.cookie = 'id=; Path=/;  Domain=' + location.host + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
// 	delete_cookie("tune");
// 	delete_cookie("basket");
// }
